import moment from "../../node_modules/moment/src/moment";
import bootstrap from "../../node_modules/bootstrap/dist/js/bootstrap.bundle.min";

window.Dropdown = bootstrap.Dropdown; // Fix for issue with the Bootstrap Select and how Rollup loads the JS

var tooltipTriggerList = [].slice.call(
  document.querySelectorAll('[data-bs-toggle="tooltip"]')
);
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  return new bootstrap.Tooltip(tooltipTriggerEl);
});
function setCookie(name, value, days) {
  var expires = "";
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

jQuery(".alert").on("click", function () {
  setCookie("alertDismissed", "1", 7);
  jQuery(".alert").alert("close");
});

function cookieSessionAlert() {
  if (!getCookie("alertDismissed")) {
    jQuery(".alert").toggleClass("d-none");
  }
}

jQuery(document).ready(function () {
  cookieSessionAlert();
  jQuery(".load-filters").hide();
  //jQuery(".modal").appendTo("body");
  jQuery(".modal").on("shown.bs.modal", function () {
    jQuery(".modal-backdrop").appendTo(jQuery(".modal.show").parent());
  });

  //script for date filter
  var currentDate = new Date();
  var currentMonth =
    currentDate.getFullYear() +
    "-" +
    ("0" + (currentDate.getMonth() + 1)).slice(-2);

  jQuery("#eventMonth").val(currentMonth);

  jQuery(".btn-month-prev").click(function () {
    var currDate = moment(jQuery(".event-month").val());
    currDate.subtract(1, "months");
    jQuery(".event-month").val(currDate.format("YYYY-MM"));
    jQuery("#event_month").val(currDate.format("YYYY-MM"));
  });
  jQuery(".btn-month-next").click(function () {
    var currDate = moment(jQuery(".event-month").val());
    currDate.add(1, "months");
    jQuery(".event-month").val(currDate.format("YYYY-MM"));
    jQuery("#event_month").val(currDate.format("YYYY-MM"));
  });

  if (jQuery(".event-list").length) {
    buildFilter();
  }
  //script to load filtered data by region
  jQuery("#eventMonth").on("change", function () {
    buildFilter();
  });

  jQuery("#filter-program_type, #filter-region").on("change", function () {
    buildFilter();
  });

  jQuery(".btn-month-prev, .btn-month-next").click(function () {
    jQuery("#event_month").hide();
    jQuery("#eventMonth").removeAttr("style");
    buildFilter();
  });

  jQuery(".filter-toggle").on("click", function (e) {
    e.preventDefault();
    jQuery(this).toggleClass("open");
    jQuery(this).next(".filter-wrap").toggleClass("open");
  });
});
function buildFilter() {
  var region = jQuery("#filter-region").val();
  var eventType = jQuery("#filter-program_type").val();

  var selector = ".event";
  if (region !== "all") {
    selector += ".region_" + region;
  }
  if (eventType !== "all") {
    selector += ".type_" + eventType.replace(/ /g, "_");
  }

  if (jQuery("#event_month:visible").length < 1) {
    var month = jQuery("#eventMonth").val().replace(/-/g, "_");
    selector += ".date_" + month;
  }

  jQuery(".no-events").hide();
  jQuery(".event").hide();
  jQuery(selector).show();
  if (jQuery(selector).length < 1) {
    jQuery(".no-events").show();
  }
}

jQuery(document).ready(function () {
      // Get all category filter select elements
      var categoryFilters = document.querySelectorAll('.category');

      // Add an event listener to each select element
      categoryFilters.forEach(function(filter) {
          filter.addEventListener('change', function() {
              // Change the 'paged' URL parameter to 1
              var url = new URL(window.location.href);
              url.searchParams.set('paged', '1');
              window.location.href = url.href;
              console.log(url.href);
          });
      });
  });

  document.addEventListener('DOMContentLoaded', function() {
    var selects = document.querySelectorAll('.form-select');
    selects.forEach(function(select) {
        select.addEventListener('change', function() {
            this.form.submit();
        });
    });
}); 


jQuery(document).ready(function () {
  if (jQuery(".wpgmza-filter-widgets").length) {
    if (jQuery(window).width() > 991) {
      jQuery(".wpgmza-filter-widgets").addClass("open");
    }

    if (jQuery(".filter-toggle.select-lake").length == 0) {

      var sel = jQuery('.wpgmza-filter-widgets select');
      var selected = sel.val(); // cache selected value, before reordering
      var opts_list = sel.find('option');
      opts_list.sort(function(a, b) { return jQuery(a).text() > jQuery(b).text() ? 1 : -1; });
      sel.html('').append(opts_list);
      sel.val(selected); // set cached selected value

      jQuery('<div class="filter-toggle select-lake"></div><h5>Select Lake:</h5>').prependTo(
        ".wpgmza-filter-widgets"
      );
      jQuery(".wpgmza-dropdown[data-field-name='2WD']").before(
        "<h5>Show only lakes with:</h5><h6>Access</h6>"
      );
      jQuery(".wpgmza-dropdown[data-field-name='Hike-in Required']").after(
        "<h6>Amenities</h6>"
      );
    }
  }

  jQuery(".wpgmza-filter-widgets").on("click", ".filter-toggle", function () {
    jQuery(this).parent().toggleClass("open");
  });

  jQuery(".main-menu .dropdown:not(.search) > .nav-link").after(
    '<a href="javascript:void(0);" class="mobile-toggle"><i class="bi bi-chevron-right"></i></a>'
  );
  jQuery("body").on("click", ".mobile-toggle", function (e) {
    e.preventDefault();
    jQuery(this).toggleClass("show");
    jQuery(this).next(".dropdown-menu").toggleClass("show");
  });
  jQuery(".ffsbc-selectpicker").selectpicker();
  /*if( /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ) {
    jQuery('.ffsbc-selectpicker').selectpicker('mobile');
  }
  else 
  {
    jQuery(".ffsbc-selectpicker").selectpicker();
  }  */
  
});

/**
 * calls the function func once within the within time window.
 * this is a debounce function which actually calls the func as
 * opposed to returning a function that would call func.
 *
 * @param func    the function to call
 * @param within  the time window in milliseconds, defaults to 300
 * @param timerId an optional key, defaults to func
 */
function callOnce(func, within = 300, timerId = null) {
  window.callOnceTimers = window.callOnceTimers || {};
  if (timerId == null) timerId = func;
  var timer = window.callOnceTimers[timerId];
  clearTimeout(timer);
  timer = setTimeout(() => func(), within);
  window.callOnceTimers[timerId] = timer;
}
class Map {
  constructor(element) {
    this.element = element;
    this.map = null;
    this.mapMarkers = [];
  }

  readMarkers() {
    // TODO replace the selector if you've changed it in the markup
    this.element
      .querySelectorAll(".my-map__marker")
      .forEach((markerElement) => {
        let lat = markerElement.dataset.hasOwnProperty("lat")
          ? markerElement.dataset["lat"]
          : 0;
        let lng = markerElement.dataset.hasOwnProperty("lng")
          ? markerElement.dataset["lng"]
          : 0;

        this.mapMarkers.push({
          lat: parseFloat(lat),
          lng: parseFloat(lng),
        });
        markerElement.remove();
      });
  }

  createMap() {
    let mapArgs = {
      zoom: parseInt(
        this.element.dataset.hasOwnProperty("zoom")
          ? this.element.dataset["zoom"]
          : 14
      ),
      mapTypeId: window.google.maps.MapTypeId.ROADMAP,
    };
    this.map = new window.google.maps.Map(this.element, mapArgs);
  }

  createMarkers() {
    this.mapMarkers.forEach((marker) => {
      new window.google.maps.Marker({
        position: marker,
        map: this.map,
      });
    });
  }

  centerMap() {
    // Create map boundaries from all map markers.
    let bounds = new window.google.maps.LatLngBounds();

    this.mapMarkers.forEach((marker) => {
      bounds.extend({
        lat: marker.lat,
        lng: marker.lng,
      });
    });

    if (1 === this.mapMarkers.length) {
      this.map.setCenter(bounds.getCenter());
    } else {
      this.map.fitBounds(bounds);
    }
  }

  init() {
    if (
      !window.hasOwnProperty("google") ||
      !window.google.hasOwnProperty("maps") ||
      !window.google.maps.hasOwnProperty("Map") ||
      !window.google.maps.hasOwnProperty("Marker") ||
      !window.google.maps.hasOwnProperty("LatLngBounds") ||
      !window.google.maps.hasOwnProperty("MapTypeId") ||
      !window.google.maps.MapTypeId.hasOwnProperty("ROADMAP")
    ) {
      console.log("Google maps isn't available");
      return;
    }

    // before the map initialization, because during creation HTML is changed
    this.readMarkers();
    this.createMap();
    this.createMarkers();
    this.centerMap();
  }
}

class Maps {
  constructor() {
    this.isMapsLoaded = false;
    this.mapsToInit = [];

    // TODO change to yours if you've defined own callback (for https://maps.googleapis.com/maps/api...)
    window.googleMapsCallback = this.mapsLoadedCallback.bind(this);

    "loading" !== document.readyState
      ? this.setup()
      : window.addEventListener("DOMContentLoaded", this.setup.bind(this));
  }

  setup() {
    const observer = new MutationObserver((records, observer) => {
      for (let record of records) {
        record.addedNodes.forEach((addedNode) => {
          this.addListeners(addedNode);
        });
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    this.addListeners(document.body);
  }

  mapsLoadedCallback() {
    this.isMapsLoaded = true;

    this.mapsToInit.forEach((map) => {
      map.init();
    });

    this.mapsToInit = [];
  }

  addListeners(element) {
    if (Node.ELEMENT_NODE !== element.nodeType) {
      return;
    }

    // TODO replace the selector if you've changed it in the markup

    element.querySelectorAll(".my-map").forEach((mapElement) => {
      let map = new Map(mapElement);

      if (!this.isMapsLoaded) {
        this.mapsToInit.push(map);

        return;
      }

      map.init();
    });
  }
}

new Maps();

const iconSearch = document.querySelector(".search");
const searchField = document.querySelector("#s-2");

iconSearch.addEventListener("click", function () {
  searchField.focus();
});
